import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="work-types--table"
export default class extends Controller {
    static targets = ["table"];

    edit(event) {
        this.tableTarget.querySelectorAll("tr").forEach((tr) => {
            tr.classList.remove("active");
        });
        this.selectedSystemSetting(event);
        }


    selectedSystemSetting(event) {
        this.element.querySelectorAll('.tblwrap .active').forEach(b => b.classList.remove('active'))
        this.element.querySelectorAll(".tblwrap .btn")
        .forEach(btn => btn.classList.remove("active"))
        event.currentTarget.classList.add("active")
    }
}
